import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { logError } from '../../utils/errorLogger.js';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    logError(error, { componentStack: info?.componentStack });
  }

  handleReload = () => {
    this.setState({ error: null, info: null });
    if (this.props.onReset) this.props.onReset();
  };

  render() {
    if (this.state.error) {
      return (
        <Box sx={{ p: 3, maxWidth: 640, m: '40px auto' }}>
          <Paper elevation={3} sx={{ p: 3, borderLeft: '6px solid #d32f2f' }}>
            <Typography variant="h5" gutterBottom color="error">Произошла ошибка</Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.75rem', mt: 2 }}>
              {String(this.state.error.message || this.state.error)}
            </Typography>
            {this.state.info?.componentStack && (
              <Typography variant="caption" sx={{ display: 'block', mt: 2, whiteSpace: 'pre-wrap', opacity: 0.7 }}>
                {this.state.info.componentStack}
              </Typography>
            )}
            <Box sx={{ mt: 3, display: 'flex', gap: 1 }}>
              <Button variant="contained" color="primary" onClick={this.handleReload}>Продолжить</Button>
              <Button variant="outlined" color="error" onClick={() => window.location.reload()}>Перезагрузить страницу</Button>
            </Box>
          </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
